<template>
  <div class="table_card">
    <div class="table_card__head">
      <v-layout row wrap fill-height>
        <v-flex xs12 lg8>
          <p class="table_card__head--title">Notificaciones</p>
          <v-breadcrumbs class="breadcums">
            <v-icon slot="divider">chevron_right</v-icon>
            <v-breadcrumbs-item
              class="breadcums__option"
            >
              Historial de notificaciones
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-flex>
        <v-flex xs12 lg4 class="filter_options">
          <v-flex class="right mr-20">
            <button
              class="faccess_button"
              @click="$router.push({name: 'notification_new'})"
            >
              Crear nueva notificación
            </button>
          </v-flex>
          <div
            class="buttom_reload"
            @click="getAlerts()"
          >
            <img src="@/assets/img/icons/refresh-icon.svg">
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div>
      <v-data-table
        :headers="headers"
        :items="notifications"
        hide-actions
        class="elevation-1"
      >
        <template slot="items" slot-scope="props" >
          <td @click="editItem(props.item)" style="cursor: pointer">{{ props.item.attributes.title }}</td>
          <td v-if="props.item.attributes.users.length > 0">
            {{ props.item.attributes.users.length == 1 ? props.item.attributes.users.length + ' correo' : props.item.attributes.users.length + ' correos'}}
          </td>
          <td v-else>
            Todos
          </td>
          <td>{{ props.item.attributes.send_date_time | moment("DD/MM/YYYY")}}</td>
          <td>{{ props.item.attributes.send_date_time | moment("hh:mm a")}}</td>
        </template>
      </v-data-table>
      <v-dialog v-model="modal_details" max-width="424px">
        <!-- <v-btn slot="activator" color="primary" dark class="mb-2">New Item</v-btn> -->
        <v-card style="border-radius: 10px">
          <v-card-title style="border-bottom: 1px solid #E9E9F0">
            <h5 class="table_card__head--title">
              <v-icon style="font-size: 30px">mark_email_unread</v-icon>
              <span class="ml-2">Detalle notificación</span>
            </h5>
          </v-card-title>
          <v-card-text style="padding: 0">
            <v-container grid-list-md style="color: #5A6B8E">
              <v-layout wrap>
                <v-flex xs12>
                  <span style="font-size: 12px; color: #5A6B8E">Título</span>
                  <p style="font-size: 14px; margin-bottom: 0; font-weight: 600">
                    {{editedItem.attributes.title}}
                  </p>
                </v-flex>
                <v-flex xs12>
                  <span style="font-size: 12px; color: #5A6B8E">Cuerpo</span>
                  <p style="font-size: 14px; margin-bottom: 0; font-weight: 600">
                    {{editedItem.attributes.message}}
                  </p>
                </v-flex>
                <v-flex
                  xs12
                  style="max-height: 150px; overflow-x: hidden; overflow-y: auto"
                  v-if="editedItem.attributes.users.length > 0">
                  <span style="font-size: 12px; color: #5A6B8E">Correos ({{editedItem.attributes.users.length}})</span>
                  <v-flex>
                    <span v-for="user in editedItem.attributes.users" :key="user">
                      <v-chip style="font-weight: 500">{{ user }}</v-chip>
                    </span>
                  </v-flex>
                </v-flex>
                <v-flex xs12>
                  <span style="font-size: 12px; color: #5A6B8E">Fecha y hora de envío</span>
                  <p style="font-size: 14px; margin-bottom: 0; font-weight: 600">
                    {{editedItem.attributes.send_date_time | moment("DD/MM/YYYY - hh:mm a")}}
                  </p>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#5A6B8E" flat @click.native="close()">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      modal_details: false,
      notifications: [],
      headers: [
          { text: 'Título', sortable: false, value: 'title' },
          { text: 'Para', value: 'users', sortable: false },
          { text: 'Fecha de envío', value: 'date', sortable: false },
          { text: 'Hora de envío', value: 'time', sortable: false },
      ],
      editedItem: {
        attributes:{
          title:'',
          message: '',
          users: [],
          send_date_time: null
        }
      },
      defaultItem: {
        attributes:{
          title:'',
          message: '',
          users: [],
          send_date_time: null
        }
      },
      editedIndex: -1
    }
  },
  mounted(){
    this.getAlerts();
  },
  methods: {
    getAlerts(){
      try {
        this.$http.get('push_messages/index',{
          headers:{
            "X-Device-ID": this.getDeviceId(),
            "Authorization": 'Bearer ' + this.getUserToken()
          }
        })
        .then(function(response){
          this.notifications = response.body.data
          // cl notifications
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          // if(typeof response.body.errors[0].details != "object"){
          //   alert(response.body.errors[0].details);
          // }else{
          //   let message = []
          //   for(var key in response.body.errors[0].details){
          //     message.push(response.body.errors[0].details[key])
          //   }
          //   alert(message);
          // }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    editItem (item) {
      this.editedIndex = this.notifications.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.modal_details = true
    },
    close () {
      this.modal_details = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/notifications/Index.vue